(() => {
  const init = () => {
    document.querySelectorAll('.amazing-glove-page .ags-movie__frame video').forEach((brandMovie) => {
      if (brandMovie.dataset.amazingInitialized === 'true') return;
      brandMovie.dataset.amazingInitialized = 'true';
      brandMovie.setAttribute('autoplay', '');
      brandMovie.setAttribute('muted', '');
      brandMovie.setAttribute('playsinline', '');
      brandMovie.setAttribute('webkit-playsinline', '');
      brandMovie.defaultMuted = true;
      brandMovie.muted = true;
      brandMovie.playsInline = true;
      let movieInView = true;
      const playBrandMovie = () => {
        if (!movieInView) return;
        brandMovie.defaultMuted = true;
        brandMovie.muted = true;
        const request = brandMovie.play();
        if (request) request.catch(() => {});
      };
      playBrandMovie();
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          movieInView = entry.isIntersecting && entry.intersectionRatio > 0;
          if (movieInView) playBrandMovie();
          else brandMovie.pause();
        });
      }, { threshold: [0, 0.01, 0.15] });
      brandMovie.addEventListener('loadedmetadata', playBrandMovie);
      brandMovie.addEventListener('loadeddata', playBrandMovie);
      brandMovie.addEventListener('canplay', playBrandMovie);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) playBrandMovie();
      });
      ['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
        document.addEventListener(eventName, playBrandMovie, { once: true, passive: true });
      });
      observer.observe(brandMovie);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
